import { Popover, Typography } from "antd";

const GuideContent = () => (
  <div style={{ maxWidth: 640 }}>
    <div style={{ marginBottom: 12 }}>
      <Typography.Text strong>Hướng dẫn tạo mức ưu đãi</Typography.Text>
    </div>
    <div style={{ borderTop: "1px dashed #e5e7eb", paddingTop: 12, marginBottom: 12 }}>
      <Typography.Paragraph style={{ marginBottom: 6 }}>
        Nếu bạn muốn <strong>Giảm 10% cho đơn hàng tối thiểu 5tr, tối đa 800k</strong> thì bạn cần thiết lập các điều
        kiện sau:
      </Typography.Paragraph>
      <Typography.Paragraph style={{ color: "#2246DC", marginBottom: 6 }}>
        % giảm * Giá trị đơn hàng tối thiểu &lt; Mức giảm tối đa ≤ Ngân sách
      </Typography.Paragraph>
      <Typography.Text type="secondary">
        Lưu ý: Bạn có thể nhập Giá trị đơn hàng tối thiểu = 0 cho loại ưu đãi giảm %
      </Typography.Text>
    </div>
    <div style={{ borderTop: "1px dashed #e5e7eb", paddingTop: 12, marginBottom: 12 }}>
      <Typography.Paragraph style={{ marginBottom: 6 }}>
        Nếu bạn muốn <strong>Giảm 10% cho đơn hàng tối thiểu 5tr và không giới hạn số tiền giảm</strong> thì bạn cần
        thiết lập các điều kiện sau:
      </Typography.Paragraph>
      <Typography.Paragraph style={{ color: "#2246DC", marginBottom: 6 }}>
        % giảm * Giá trị đơn hàng tối thiểu &lt; Ngân sách
      </Typography.Paragraph>
      <Typography.Text type="secondary">
        Lưu ý: Bạn có thể nhập Giá trị đơn hàng tối thiểu = 0 cho loại ưu đãi giảm %
      </Typography.Text>
    </div>
    <div style={{ borderTop: "1px dashed #e5e7eb", paddingTop: 12 }}>
      <Typography.Paragraph style={{ marginBottom: 6 }}>
        Nếu bạn muốn <strong>Giảm 500k cho đơn hàng tối thiểu 5tr</strong>, thì bạn cần thiết lập các điều kiện sau:
      </Typography.Paragraph>
      <Typography.Paragraph style={{ color: "#2246DC", marginBottom: 6 }}>
        0 &lt; Giá trị giảm tiền &lt; Giá trị đơn hàng tối thiểu và Giá trị giảm tiền ≤ Ngân sách
      </Typography.Paragraph>
      <Typography.Text type="secondary">
        Lưu ý: Giá trị đơn hàng tối thiểu &gt; 0 cho loại ưu đãi giảm tiền
      </Typography.Text>
    </div>
  </div>
);

export const GuidePopoverLink = () => (
  <Popover content={<GuideContent />} trigger="click" placement="bottomRight">
    <Typography.Link>Xem hướng dẫn tạo mức ưu đãi</Typography.Link>
  </Popover>
);

export default GuidePopoverLink;
